export default __webpack_public_path__ + "static/media/539.d5913431.png";